module.exports = __webpack_public_path__ + "static/media/preloader.d276fef2.gif";